import React, { useContext } from 'react'
import { View } from 'oio-react'
import { useMessageList } from 'src/graphql/hooks'
import Title from 'src/apps/CustomApp/components/Title'
import ActivityMessageListItem from 'src/apps/Messages/components/ActivityListItem'
import MessagesContext from 'src/apps/Messages/components/Context'
import { InitiativeHierarchyContext } from 'src/libraries/contexts/InitiativeHierarchy'
import ThemeContext from 'src/libraries/contexts/Theme'

const ActivityView = () => {
   const theme = useContext(ThemeContext)

   const { initiative } = useContext(InitiativeHierarchyContext)
   const { messageList } = useMessageList({
      limit: 30,
      sortBy: 'dateDesc',
      threadId: initiative.thread.id,
      type: 'activity'
   })

   return (
      <View
         display="flex"
         flexFlow="column"
         position="relative"
         width="100%"
         height="100%"
         paddingHorizontal="40px"
         backgroundColor={theme.tmpContentBackgroundColor}>
         <View
            flex="0 0 auto"
            display="flex"
            justifyContent="space-between"
            width="100%"
            paddingVertical={theme.tmpSpacingTop}
            backgroundColor={theme.tmpContentBackgroundColor}
            borderBottom={`1px solid ${theme.tmpContentLineColor}`}>
            <Title size="md" color={theme.tmpContentTitleColor}>Activity</Title>
         </View>
         <View flex="1 1 auto" scroll="on">
            <MessagesContext.Provider initiativeId={initiative.id}>
               {messageList.items.map((message, index) => (
                  <ActivityMessageListItem
                     {...message}
                     key={message.id}
                     initiative={undefined}
                     body={message.body}
                     borderStyle={index === 0
                        ? 'none'
                        : `1px solid ${theme.tmpContentLineColor}`
                     }
                     dateAdded={message.dateAdded}
                     textColor={theme.tmpContentTextColor}
                  />
               ))}
            </MessagesContext.Provider>
         </View>
      </View>
   )
}

export default ActivityView
